/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

import React from "react";
import { observer } from "mobx-react";
import { injectIntl } from "react-intl";
import { AppContainer as AppContainerBase } from "bundle/preview/react-component/main-app/container/AppContainer";
import ServiceRegistry from "bundle/util/ServiceRegistry";
import NotSupportedPageContainer from "app/preview/react-component/not-supported/container/NotSupportedPageContainer";
import { isIE, isLegacyEdge } from "app/util/AppUtil";
import { PropTypes } from "prop-types";

@observer
class AppContainer extends AppContainerBase {
    static propTypes = {
        intl: PropTypes.object.isRequired,
    };

    // eslint-disable-next-line react/no-deprecated
    componentWillMount() {
        ServiceRegistry.getService("EmbedModeService").preComponentMount();
    }

    render() {
        if (!this._oneTimeMessage) {
            ServiceRegistry.getService("LoggingService").logExternal("App attached to DOM.");
            this._oneTimeMessage = true;
        }
        const date = new Date();
        const endDate = new Date(2021, 9, 1);
        if ((isIE() || isLegacyEdge()) && (date > endDate)) {
            this._appStore.setAppClosed(true);
            return (
                <React.Fragment>
                    <NotSupportedPageContainer />
                </React.Fragment>
            );
        }
        return (
            <React.Fragment>
                {
                    super.render()
                }
            </React.Fragment>
        );
    }
}

const injectedAppContainer = injectIntl(AppContainer);

export default injectedAppContainer;
